import { c as _c } from "react/compiler-runtime";
import { classNames, Flex } from "@opensea/ui-kit";
export function StepIndicator(t0) {
  const $ = _c(7);
  const {
    selected,
    completed,
    hidden,
    onClick
  } = t0;
  if (hidden) {
    return null;
  }
  const t1 = completed ? "w-2 hover:h-3" : "w-12 md:w-24";
  const t2 = onClick && "cursor-pointer";
  const t3 = selected || completed ? "bg-white" : "bg-white/15";
  let t4;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3) {
    t4 = classNames("h-2 rounded-full", "transition-[width,height,background-color] duration-300 ease-out-quint", t1, t2, t3);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onClick || $[5] !== t4) {
    t5 = <Flex className={t4} onClick={onClick} />;
    $[4] = onClick;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}